import axios from "../utiles/axios.util";

function apiGetRcpMng(order_no) {
    return axios.get(`/api/v1/rcpMng?order_no=${order_no}`);
}

function apiGetRcpMngDetail() {
    return axios.get(`/api/v1/rcpMng/detail`);
}

function apiPostRcpMng(formData) {
    return axios.post("/api/v1/rcpMng", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

function apiGetRcpList(sdate, edate) {
    return axios.get(`/api/v1/rcpMng/list?sdate=${sdate}&edate=${edate}`);
}

export { apiGetRcpMng, apiGetRcpMngDetail, apiPostRcpMng, apiGetRcpList };
